import ModelBase from "./shared/model-base.js";

interface CountryAttributes {
  id: string | number;
  code?: string;
  name?: string;
  flag?: string;
  position?: number;
}

interface ModelAttributes {
  id: string | number;
  email?: string;
  name?: string;
  phone?: string;
  role?: string;
  avatar_url?: string;
  title?: string;
  company?: string;
  office_phone?: string;
  mobile_phone?: string;
  website?: string;
  line_url?: string;
  facebook_url?: string;
  tiktok_url?: string;
  instagram_url?: string;
  linkedin_url?: string;
  wechat_url?: string;
  country_id: string | number;
  country?: CountryAttributes;
  is_active?: boolean;
  bio?: string;
  certifications?: { name: string }[];
  specialties?: { name: string }[];
  created_at?: string;
  updated_at?: string;
  role_text?: string;
}

const OPTIONS = {
  i18nModelName: "member",
  columns: [
    "id",
    "email",
    "name",
    "phone",
    "role",
    "avatar_url",
    "title",
    "company",
    "office_phone",
    "mobile_phone",
    "website",
    "line_url",
    "facebook_url",
    "tiktok_url",
    "instagram_url",
    "linkedin_url",
    "wechat_url",
    "country_id",
    "country",
    "is_active",
    "bio",
    "certifications",
    "specialties",
    "created_at",
    "role_text",
  ],
  editColumns: {},
};

export default class Member extends ModelBase {
  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}
